import script from "./ProductReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductReview.vue?vue&type=script&setup=true&lang=ts"

import "./ProductReview.vue?vue&type=style&index=0&id=e5243afc&scoped=true&lang=css"

import exportComponent from "/home/forge/client.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5243afc"]])

export default __exports__